import { render, staticRenderFns } from "./templateSingleOptionCard.vue?vue&type=template&id=204de065&scoped=true"
import script from "./templateSingleOptionCard.vue?vue&type=script&lang=js"
export * from "./templateSingleOptionCard.vue?vue&type=script&lang=js"
import style0 from "./templateSingleOptionCard.vue?vue&type=style&index=0&id=204de065&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204de065",
  null
  
)

export default component.exports